import React from 'react';
import HeroSection from './components/HeroSection';
import MarqueeSection from './components/MarqueeSection';
import FormSection from './components/FormSection';
import AboutSection from './components/AboutSection';
import GallerySection from './components/GallerySection';
import HistorySection from './components/HistorySection';
import VenuesSection from './components/VenuesSection';
import CompilationsSection from './components/CompilationsSection';
import MerchandiseSection from './components/MerchandiseSection';
import FooterSection from './components/FooterSection';
import LegalPage from './components/LegalPage';

function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';

  if (path === '/legal') {
    return <LegalPage />;
  }

  return (
    <div className="App">
      <HeroSection />
      <MarqueeSection />
      <FormSection />
      <AboutSection />
      <GallerySection thumbnailsPerPage={3} />
      <HistorySection />
      <VenuesSection />
      <CompilationsSection />
      <MerchandiseSection />
      <FooterSection />
    </div>
  );
}

export default App;
